// extracted by mini-css-extract-plugin
export var recList = "styles-module--recList--516d3";
export var recommendations = "styles-module--recommendations--856c1";
export var recs = "styles-module--recs--48e7b";